module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "turn-on-controller"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img-base64', {
    attrs: {
      "name": 'reset_' + _vm.deviceName
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.tips))]), _vm._v(" "), _c('div', {
    staticClass: "next-btn"
  }, [_c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStepClick
    }
  }, [_vm._v("下一步")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ced1563"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/wifi/TurnOn.vue
// module id = 882
// module chunks = 1